import Vue from 'vue'
import App from './App.vue'
import router from './router'
import  store  from './store';
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';

import { ElementTiptapPlugin } from 'element-tiptap';
import 'element-tiptap/lib/index.css';
import cn from "./lang/cn.json";
import hk from "./lang/hk.json";
import en from "./lang/en.json";
import Axios from "axios";
import ajax from './common/axios.config'

import '@/assets/css/common.css'

Vue.prototype.$axios =Axios;
//注册到vue原型上
let BaseUrl=''
let Claude3Url = 'https://claude3.cocorobo.cn/';
let QwenUrl = 'https://llm.cocorobo.cn/'
let lang = new Object();
let speech_url="";
let magic_brush_url="";
let domain_name=""
let isHk=null;
let new_url=null;
if(window.location.href.includes('localhost') || window.location.href.includes('192.168')){
  BaseUrl='https://gpt4.cocorobo.cn/';
  new_url='https://appapi.cocorobo.cn';
  // new_url='http://127.0.0.1:8000';
  //new_url='http://18.208.143.107:8001'; 
}else{
  BaseUrl='//gpt4.cocorobo.cn/';
  new_url='https://appapi.cocorobo.cn'
}
// BaseUrl='http://gpt4.cocorobo.cn:8011/';
if (window.location.href.includes("cocorobo.cn")) {
  isHk=false;
  document.domain = "cocorobo.cn";
  lang = cn;
  domain_name="cn";
  speech_url="https://beta.cloud.cocorobo.cn/browser/public/index.html";
  magic_brush_url="https://real.cocorobo.cn/";
} else if (window.location.href.includes("cocorobo.hk")) {
  isHk=true;
  document.domain = "cocorobo.hk";
  lang = hk;
  domain_name="hk";
  speech_url="https://cloud.cocorobo.hk/browser/public/index.html";
  magic_brush_url="https://real.cocorobo.hk/";
} else if (window.location.href.includes("cocorobo.com")) {
  isHk=true;
  document.domain = "cocorobo.com";
  lang=en;
  domain_name="com";
  speech_url="https://cloud.cocorobo.hk/browser/public/index.html";
  magic_brush_url="https://real.cocorobo.hk/";
}else{
  isHk=false;
  lang=cn;
  domain_name="cn";
  speech_url="https://cloud.cocorobo.hk/browser/public/index.html";
  magic_brush_url="https://real.cocorobo.hk/";
}
let user={};
try {
  // 尝试访问父页面的 location.href（可能因跨域而失败）
  if(parent && parent !== window && parent.location?.href){
    user.is_table = parent.location.href.includes('liyuan') || false;
  } else {
    user.is_table = true;
  }
} catch (error) {
  // 跨域访问被浏览器阻止时，捕获 SecurityError
  console.warn('无法访问父页面信息（跨域限制），使用默认配置');
  console.error('跨域访问错误详情:', error);
  user.is_table = true;
}

let US = {};
function safeGetUS(win) {
  try {
    return win?.US || {};
  } catch (e) {
    return {};
  }
}
US = safeGetUS(top);
if (!US || Object.keys(US).length === 0) {
  US = safeGetUS(parent?.parent);
}
if (!US || Object.keys(US).length === 0) {
  US = safeGetUS(parent);
}
if (!US || Object.keys(US).length === 0) {
  console.log('获取上级页面失败');
}

let urlArea = window.location.href.includes("cocorobo.com") ? 'com' : window.location.href.includes("cocorobo.hk") ? 'hk' : 'cn';
console.log('urlArea',urlArea);


if(US?.userInfo){
  user.userId = US?.userInfo?.userid;
  user.userName = US?.userInfo?.username;
  user.organizeid = US?.userInfo.organizeid;
  user.org = US?.userInfo.org; //學校id
  user.orgArea = urlArea || "cn";
  console.log('user.orgArea',US?.userInfo.orgArea);
  // user.orgArea = US?.userInfo.orgArea || US?.userInfo.schoolArea || "cn";
  user.type = US?.userInfo?.type;
}else{
  if(window.location.href.includes('http://localhost:')||window.location.href.includes('local.cocorobo.cn')){
    // user.userId = '602def61-005d-11ee-91d8-005056b86db5';
    // user.userName ="huangminghao";
    // user.organizeid = '45facc0a-1211-11ec-80ad-005056b86db5';
    // user.org = '';
    // user.orgArea ="cn";

		// user.userId = '6c06f049-86d7-11f0-9c7b-005056924926';
    // user.userId = 'a77e9404-efec-11e9-96f9-028edca3b798'
		user.userId = '6c56ec0e-2c74-11ef-bee5-005056b86db5';
		// user.userId = 'd0c3d31e-b3d9-11f0-a63c-005056924926';
    // user.userId = 'd277f0bd-afdc-11f0-a63c-005056924926';
    user.userName ="qgt";
    // user.organizeid = '56ca35f7-1b6e-11f0-a66a-005056924926';
    // user.org = '292e34dc-1b6e-11f0-a66a-005056924926';
    user.organizeid = '414f2361-ad04-11ed-b13d-005056b86db5';
    user.org = '0fec3a8a-ad04-11ed-b13d-005056b86db5';
    user.orgArea ="cn";
    user.type = 1;

  }else if(window.location.href.includes('dialogMode?id')||window.location.href.includes('appSelection')){
    console.log('dialogMode')
  }
  else{
    //window.location.href='https://cloud.cocorobo.cn/'
  }
}

if(window.location.href.includes('pptMode')){
  store.commit('set_mode', 'pptMode');
}

store.commit('set_user', user);
Vue.prototype.user = user;
Vue.prototype.domain_name =domain_name;
Vue.prototype.ajax = ajax
Vue.prototype.new_url=new_url;
Vue.prototype.speech_url =speech_url;
Vue.prototype.magic_brush_url =magic_brush_url;
Vue.prototype.lang =lang;
Vue.prototype.bus = new Vue();
Vue.prototype.$isHk = isHk;
Vue.prototype.GLOBAL = {
  Base_Url: BaseUrl,
  Claude3_Url:Claude3Url,
  Qwen_Url: QwenUrl,
  copyData: {
    selectData:[],
    stageData: [],
    tasksData: [],
    questionData: []
  },
  domain_flag:true
};

Vue.config.productionTip = false
if(domain_name==='com'){//英文版
	Vue.use(ElementUI,{locale})
}else{
	Vue.use(ElementUI)
}
Vue.use(ElementTiptapPlugin, {
  lang: "zh", // see i18n
});
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
